import axios from "axios";
import { message, notification } from "ant-design-vue";
import { GET_TOKEN, REMOVE_TOKEN } from "@/utils/token";
import router from "@/router";
const isDev = process.env.NODE_ENV === "development";
const request = axios.create({
  //本地环境是请求拼接+转发
  baseURL: isDev ? "http://localhost:8102" : "https://leddie.icu",
  timeout: 100000,
  withCredentials: true,
});
// 添加请求拦截器
// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const token = GET_TOKEN(); // 从 token 工具中获取 token
    if (token) {
      // 根据后端要求选择合适的 header 字段
      config.headers["Authorization"] = `${token}`;
      // 或者使用其他格式，如：
      // config.headers['token'] = token;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  (response) => {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // console.log(response);
    return response.data;
  },
  (error) => {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    const status = error.response?.status;
    let errorMsg = "接口请求错误";
    if (status === 401 || status === 403) {
      errorMsg = "登录已过期，请重新登录";
      REMOVE_TOKEN();
      // 跳转登录页
      router.push({
        path: "/login",
        query: { redirect: router.currentRoute.value.fullPath },
      });
    } else if (status === 404) {
      errorMsg = "网络请求不存在";
    } else if (status === 500) {
      errorMsg = "服务器出现问题";
    } else if (error.response?.data?.message) {
      errorMsg = error.response.data.message;
    }
    notification.error({
      message: "错误",
      description: errorMsg,
    });
    return Promise.reject(error);
  }
);

export default request;
